import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Select, Popconfirm, Space } from "antd";
import { IconPlus, IconPencil, IconTrash } from "@tabler/icons-react";
import PageHeader from "../../components/header/PageHeader";
import KeywordFormModal from "./KeywordFormModal";
import api from "../../api";
import { useToast } from "../../components/toast";

export default function Keywords() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groupFilter, setGroupFilter] = useState(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const toast = useToast();

  const fetchList = async () => {
    setLoading(true);
    const res = await api.keywords_list();
    if (res?.status === 200) setData(res.data);
    else toast(res?.data?.message || "Алдаа гарлаа", "error");
    setLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const onDelete = async (id) => {
    const res = await api.keywords_remove(id);
    if (res?.status === 200) {
      toast("Устгагдлаа", "success");
      setData((prev) => prev.filter((k) => k.id !== id));
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
  };

  // Байгаа group-уудыг цуглуулна — modal-ийн Select-д ашиглана
  const existingGroups = [...new Set(data.map((k) => k.group).filter(Boolean))];

  const filtered = groupFilter
    ? groupFilter === "__single__"
      ? data.filter((k) => !k.group)
      : data.filter((k) => k.group === groupFilter)
    : data;

  const columns = [
    {
      title: "Түлхүүр",
      dataIndex: "key",
      width: 260,
      render: (v) => <span style={{ fontWeight: 600, fontSize: 13 }}>{v}</span>,
    },
    {
      title: "Утга",
      dataIndex: "value",
      render: (v) => <span style={{ fontSize: 13 }}>{v}</span>,
    },
    {
      title: "Багц",
      dataIndex: "group",
      width: 350,
      render: (v) => (v ? <Tag color="blue">{v}</Tag> : "-"),
    },
    {
      title: "",
      width: 90,
      render: (_, r) => (
        <Space size={4}>
          <Button
            type="text"
            size="small"
            icon={<IconPencil size={15} />}
            onClick={() => {
              setEditingRow(r);
              setModalOpen(true);
            }}
          />
          <Popconfirm
            title="Устгах уу?"
            okText="Устгах"
            cancelText="Болих"
            onConfirm={() => onDelete(r.id)}
          >
            <Button
              danger
              type="text"
              size="small"
              icon={<IconTrash size={15} />}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <section className="keywords-section">
      <PageHeader
        title="Keywords"
        sub="Сайт дээр харагдах текст утгууд"
        rSide={
          <Button
            type="primary"
            icon={<IconPlus size={16} />}
            onClick={() => {
              setEditingRow(null);
              setModalOpen(true);
            }}
          >
            Нэмэх
          </Button>
        }
      />

      <Select
        allowClear
        placeholder="Бүлгээр шүүх"
        style={{ width: 220, marginBottom: 16 }}
        value={groupFilter}
        onChange={setGroupFilter}
        options={[
          { value: "__single__", label: "Дан keyword" },
          ...existingGroups.map((g) => ({ value: g, label: g })),
        ]}
      />

      <div className="table-wrap">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={filtered}
          pagination={false}
          size="middle"
        />
      </div>

      <KeywordFormModal
        open={modalOpen}
        editingRow={editingRow}
        existingGroups={existingGroups}
        onClose={() => setModalOpen(false)}
        onSuccess={fetchList}
      />
    </section>
  );
}
